<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "DvoranaBase"
}
</script>

<style scoped>

</style>